import axios from 'axios';

const URL = 'https://portalapi.cozimax.com.br';

//const URL = 'http://localhost:3200';

const api = axios.create({
   baseURL : URL,
   auth :{username:'cozimax2023',password:'cozimax2023'}
});


export default api;